import { render } from "./AiProfileFormModal.vue?vue&type=template&id=0f8d64bf&scoped=true"
import script from "./AiProfileFormModal.vue?vue&type=script&lang=js"
export * from "./AiProfileFormModal.vue?vue&type=script&lang=js"

import "./AiProfileFormModal.vue?vue&type=style&index=0&id=0f8d64bf&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f8d64bf"]])

export default __exports__